"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWorkspaceRequestV3 = void 0;
var CreateWorkspaceRequestV3;
(function (CreateWorkspaceRequestV3) {
    let Mode;
    (function (Mode) {
        Mode["PRO"] = "Pro";
        Mode["EXPERT"] = "Expert";
    })(Mode = CreateWorkspaceRequestV3.Mode || (CreateWorkspaceRequestV3.Mode = {}));
})(CreateWorkspaceRequestV3 || (exports.CreateWorkspaceRequestV3 = CreateWorkspaceRequestV3 = {}));
